import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function SentIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="33.564" height="23.672" viewBox="0 0 33.564 23.672" {...props}>
      <g id="Group_6285" data-name="Group 6285" transform="translate(-569.177 -2873.303)">
        <path 
          id="Path_6507" 
          data-name="Path 6507" 
          d="M589.558,2893.2c-5.608.143-11.24.071-16.8-.214a1.385,1.385,0,0,1-1.263-1.182,88.055,88.055,0,0,1-.009-14.909l4.681,3.616c2.252,1.737,4.574,3.528,6.888,5.319a1,1,0,0,0,1.207.013c4.165-3.086,8.332-6.171,12.139-8.976.224,2.635.319,5.289.3,7.937.648.315,1.3.645,1.978,1a90.528,90.528,0,0,0-.3-9.239,3.413,3.413,0,0,0-3.119-2.971,222.037,222.037,0,0,0-22.669,0,3.409,3.409,0,0,0-3.093,3,90.069,90.069,0,0,0,0,15.414,3.407,3.407,0,0,0,3.12,2.972c3.755.193,7.537.288,11.319.288q2.617,0,5.23-.066C589.276,2894.571,589.4,2893.908,589.558,2893.2Zm-5.6-17.9c3.623,0,7.241.094,10.83.272-3.507,2.585-7.3,5.39-11.106,8.212-2.116-1.637-4.232-3.269-6.29-4.858l-4.34-3.351C576.673,2875.4,580.318,2875.3,583.959,2875.3Z" 
          fill="currentColor"
        />
        <path 
          id="Path_6397" 
          data-name="Path 6397" 
          d="M602.148,2890.558c-3.256-1.6-6.54-3.562-9.259-4.615a.834.834,0,0,0-1.065.507.812.812,0,0,0-.048.293,27.3,27.3,0,0,0,.693,3.879c1.94.117,3.885.288,5.831.462a.35.35,0,1,1,0,.7c-1.933.174-3.866.343-5.792.46a27.681,27.681,0,0,0-.732,3.881.831.831,0,0,0,.812.85.843.843,0,0,0,.3-.05c2.719-1.053,6-3.018,9.259-4.615a.944.944,0,0,0,0-1.752Z" 
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
}

export default SentIcon;



// WEBPACK FOOTER //
// ./src/components/icons/SentIcon.jsx